var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.icon,_vm._g({tag:"component",class:_vm.classList,attrs:{"aria-label":_vm.icon}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }